import React from 'react';
import { Award } from 'lucide-react';
const instructors = [{
  name: 'Grandmaster Joe Walker',
  rank: '7th Dan',
  image: 'https://cdn.magicpatterns.com/uploads/nh1Fx2U4VLVqWRnsonycYP/Master_Joe_Walker.png'
}, {
  name: 'Master Gabriel Walker',
  rank: '6th Dan',
  image: 'https://cdn.magicpatterns.com/uploads/ioM2wh4YMpiqP7G9dUcsrR/Master_Gabriel_Walker.png'
}, {
  name: 'Master Caitlin Ketterer',
  rank: '5th Dan',
  image: 'https://cdn.magicpatterns.com/uploads/n17WVsbokZtKGqBrvmPFdb/Master_Caitlin_Ketterer.png'
}];
export function AboutInstructors() {
  return <section className="py-20 bg-black" data-id="element-388">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-389">
        <h2 className="text-3xl font-bold text-white mb-16 text-center" data-id="element-390">
          Our Instructors
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-391">
          {instructors.map((instructor, index) => <div key={instructor.name} className="animate-scroll-fade-up bg-[#1a1a1a] rounded-2xl overflow-hidden border border-gray-800 hover:border-[#00D4FF]/50 transition-colors group" style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-392">
              <div className="relative h-64 overflow-hidden" data-id="element-393">
                <img src={instructor.image} alt={instructor.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-394" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-395" />
              </div>
              <div className="p-6" data-id="element-396">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-397">
                  {instructor.name}
                </h3>
                <div className="flex items-center gap-2 text-[#00D4FF]" data-id="element-398">
                  <Award className="w-5 h-5" data-id="element-399" />
                  <span className="font-semibold" data-id="element-400">{instructor.rank}</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}